import { useState } from 'react';
import { UserWizardStep } from '@/features/onboarding/types/onboarding.types';
import { WelcomeStep } from './steps/WelcomeStep';
import { CompanyInfoStep } from './steps/CompanyInfoStep';
import { PersonalInfoStep } from './steps/PersonalInfoStep';
import { WaitingApprovalStep } from './steps/WaitingApprovalStep';
import styles from './Onboarding.module.css';


export function OnboardingUserWizard() {
    const [currentStep, setCurrentStep] = useState<UserWizardStep>('WELCOME');
    const [customerId, setCustomerId] = useState<string>('');

    const goToCompanyInfo = () => setCurrentStep('COMPANY_INFO');
    const goToPersonalInfo = (validatedCustomerId: string) => {
        setCustomerId(validatedCustomerId);
        setCurrentStep('PERSONAL_INFO');
    };
    const goToWaitingApproval = () => setCurrentStep('WAITING_APPROVAL');

    return (
        <div className={styles.wizardContainer}>
            {currentStep === 'WELCOME' && <WelcomeStep onSuccess={goToCompanyInfo} />}
            {currentStep === 'COMPANY_INFO' && <CompanyInfoStep onSuccess={goToPersonalInfo} />}
            {currentStep === 'PERSONAL_INFO' && (
                <PersonalInfoStep customerId={customerId} onSuccess={goToWaitingApproval} />
            )}
            {currentStep === 'WAITING_APPROVAL' && <WaitingApprovalStep />}
        </div>
    );
}
